import { render, staticRenderFns } from "./RequestPricelist.vue?vue&type=template&id=040aea20&scoped=true&"
import script from "./RequestPricelist.vue?vue&type=script&lang=js&"
export * from "./RequestPricelist.vue?vue&type=script&lang=js&"
import style0 from "./RequestPricelist.vue?vue&type=style&index=0&id=040aea20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040aea20",
  null
  
)

export default component.exports